import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListOrdered = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 12h11" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 18h11" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 6h11" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 10h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 6h1v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" })
	]
});
export default SvgListOrdered;
